// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_nd-0";
export var animationContainer = "_nd-1";
export var itemPrice = "_nd-a";
export var itemizedContent = "_nd-9";
export var itemizedHeader = "_nd-7";
export var itemizedRow = "_nd-8";
export var itemizedSection = "_nd-6";
export var modalContent = "_nd-2";
export var orderName = "_nd-3";
export var refundOption = "_nd-4";
export var refundOptionsContainer = "_nd-5";
export var shippingLabel = "_nd-b";
export var totalRow = "_nd-c";